export default __webpack_public_path__ + "static/media/step1@2x.5a9c6611.jpg";